import { lazy } from "react"
import { PermissionProtectedRoute } from "~/router/outlets/PermissionProtectedRoute"
import { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"

const BenefitsPage = lazy(() => import("./pages/BenefitsPage"))
const EnrollmentPage = lazy(() => import("./pages/EnrollmentPage"))
const EditEnrollmentPage = lazy(() => import("./pages/EditEnrollmentPage"))

const BenefitPlansPage = lazy(() => import("./pages/BenefitPlansPage"))
const ReconciliationPage = lazy(() => import("./pages/ReconciliationPage"))
const EnrollmentDetailsPage = lazy(() => import("./pages/EnrollmentDetailsPage"))

const ChangeBenefitsPackagePage = lazy(() => import("./pages/ChangeBenefitsPackagePage"))
const CancelBenefitPackagePage = lazy(() => import("./pages/CancelBenefitsPackagePage"))

const DependentEnrollmentPage = lazy(() => import("./pages/DependentEnrollmentPage"))

const CreateUpdateDependentPage = lazy(() => import("./pages/Dependents/CreateUpdateDependentPage"))

const BenefitsOfferingPage = lazy(() => import("./pages/BenefitsOfferingPage"))

export const staffBenefitsRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      path: "benefits",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <BenefitsPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefit-plans",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <BenefitPlansPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/enroll-team-member/:engagementStrongId/new",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <EnrollmentPage />,
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/enroll-team-member/:enrollmentStrongId/edit",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <EditEnrollmentPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefit-reconciliation",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <ReconciliationPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/:employmentStrongId/change-package",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <ChangeBenefitsPackagePage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/:employmentStrongId/change-package/:tierStrongId",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <ChangeBenefitsPackagePage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/:employmentStrongId/change-package/:previousTierStrongId/cancel-enrollments/:tierStrongId",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <CancelBenefitPackagePage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/enrollment/:strongId/details",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <EnrollmentDetailsPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/enrollment/:enrollmentStrongId/dependent-enrollment",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <DependentEnrollmentPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/enrollment/:enrollmentStrongId/dependent-enrollment/:dependentEnrollmentStrongId",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <DependentEnrollmentPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/dependents/new/:employmentStrongId",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <CreateUpdateDependentPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/dependents/edit/:employmentStrongId/:dependentStrongId",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <CreateUpdateDependentPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "benefits/offering",
      element: (
        <PermissionProtectedRoute permissions={["benefits_advisor"]}>
          <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
            <BenefitsOfferingPage />
          </LazyLoadingSuspenseWithErrorBoundary>
        </PermissionProtectedRoute>
      ),
    },
  ],
  DeprecatedFullScreen: [],
}
